import {RefreshCw} from 'lucide-react';
import * as React from 'react';
import {Button} from 'src/Button';
import {useSyncUpdatesAvailable} from 'src/hooks/useSyncUpdatesAvailable';
import {cn} from 'src/lib/utils';
import {useModals} from 'src/Modals';

export const HeaderSyncButton = ({
  className,
  ...props
}: React.ComponentProps<'button'>) => {
  const modals = useModals();
  const updatesAvailable = useSyncUpdatesAvailable();

  const handleClick = () => {
    modals.syncModal.openModal({});
  };

  return (
    <Button
      {...props}
      variant="ghost"
      size="icon"
      onClick={handleClick}
      className={cn('relative', className)}
    >
      <RefreshCw className="size-5" />
      {updatesAvailable && (
        <span className="absolute right-1.5 top-1.5 size-2 rounded-full bg-blue-500" />
      )}
    </Button>
  );
};
